import {OriginAnchor} from '../synoptic-arg-types';
import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isOriginAnchor(anchor: any): CsvConfigJsonResult {
  const validAnchors: OriginAnchor[] = [
    'top left', 'top center', 'top right',
    'center left', 'center center', 'center right',
    'bottom left', 'bottom center', 'bottom right'
  ];
  let valid: boolean = true;
  let errors = [];
  if (!validAnchors.includes(anchor)) {
    errors.push({code: 'invalidValue', key: 'originAnchor', value: anchor});
    valid = false;
  }
  return {result: valid, errors: errors};
}
